module.exports = __webpack_public_path__ + "static/media/noise.17ab2292.png";